import React, { useState } from "react";
import { Formik } from "formik";
import { MemberLoginShema } from "../../../validations/MemberLoginShema";
import { Login } from "../../api";
import { toast } from "react-toastify";
import RegisterForm from "./RegisterForm";
import PhoneInputW from "../../Reservation/PhoneInput";

import ForgotForm from "./ForgotForm";
import { useTranslation } from "../../../context/TranslationContext";

const MemberLoginForm = ({ checkLogin }) => {
  const {
    loginSuccess: loginSuccessText,
    loginError,
    password: passwordLabel,
    login: loginBtn,
    forgotPassword: forgotPasswordBtn,
    noAccount: noAccountText,
    register: registerBtn,
    phone: phoneLabel,
  } = useTranslation();
  const [mode, setMode] = useState("login"); // "login", "register" or "forgot-password"

  if (mode === "register") {
    return (
      <RegisterForm
        onBackToLogin={() => setMode("login")}
        checkLogin={checkLogin}
      />
    );
  }

  if (mode === "forgot-password") {
    return <ForgotForm onBackToLogin={() => setMode("login")} />;
  }

  return (
    <div className="w-full">
      <Formik
        initialValues={{
          phone: "",
          password: "",
        }}
        validationSchema={MemberLoginShema}
        onSubmit={async (values, actions) => {
          try {
            const data = {
              userName: values.phone,
              password: values.password,
            };
            const response = await Login(data);

            if (response.data.error) {
              localStorage.removeItem("reservations_auth");
              toast.error(response.data.error);
            } else {
              localStorage.setItem("reservations_auth", response.data.token);
              toast.success(loginSuccessText);
              checkLogin();
            }
          } catch (error) {
            console.error("Member Login error:", error);
            toast.error(loginError);
          } finally {
            actions.setSubmitting(false);
          }
        }}
      >
        {(props) => (
          <form className="mb-6 w-full" onSubmit={props.handleSubmit}>
            <div className="relative z-0 mb-[13px] w-full group h-[60px]">
              {/*<input
                type="text"
                id="phone"
                name="phone"
                className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                placeholder=" "
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.phone}
              ></input>
              <label
                htmlFor="phone"
                className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
              >
                Telefon Numarası
              </label>*/}
              <PhoneInputW
                label={phoneLabel}
                validname="phoneValid"
                isrequired="required"
                name="phone"
                mode="simple"
              ></PhoneInputW>
            </div>
            <div className="relative z-0 mb-[13px] w-full group">
              <input
                type="password"
                id="password"
                name="password"
                className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-[#dee9ed] appearance-none  focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
                placeholder=" "
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.password}
              ></input>
              <label
                htmlFor="password"
                className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
              >
                {passwordLabel}
              </label>
            </div>
            <button
              disabled={props.isSubmitting || !props.isValid || !props.dirty}
              type="submit"
              className="text-white w-full px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm text-center disabled:opacity-60 disabled:cursor-not-allowed mb-4"
            >
              {loginBtn}
            </button>
            <div className="flex justify-end mb-6">
              <button
                type="button"
                onClick={() => setMode("forgot-password")}
                className="text-xs text-[#A2B2B8] hover:text-product-type-color transition-colors"
              >
                {forgotPasswordBtn}
              </button>
            </div>
          </form>
        )}
      </Formik>

      <div className="flex justify-center items-center w-full mb-5">
        <span className="text-sm text-[#A2B2B8] mr-2">{noAccountText}</span>
        <button
          onClick={() => setMode("register")}
          className="text-sm font-bold text-product-type-color hover:underline"
        >
          {registerBtn}
        </button>
      </div>
    </div>
  );
};

export default MemberLoginForm;
